"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preact = require("preact");

var UserIcon = function UserIcon(_ref) {
  var width = _ref.width,
      height = _ref.height,
      color = _ref.color,
      className = _ref.className;
  return (0, _preact.h)(
    "svg",
    { xmlns: "http://www.w3.org/2000/svg", width: width, height: height, viewBox: "0 0 500 500", className: className },
    (0, _preact.h)("path", {
      fill: color,
      stroke: "white",
      "stroke-width": "0",
      d: "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm128 421.6c-35.9 26.5-80.1 42.4-128 42.4s-92.1-15.9-128-42.4V416c0-35.3 28.7-64 64-64 11.1 0 27.5 11.4 64 11.4 36.6 0 52.8-11.4 64-11.4 35.3 0 64 28.7 64 64v13.6zm30.6-27.5c-6.8-46.4-46.3-82.1-94.6-82.1-20.5 0-30.4 11.4-64 11.4S204.6 320 184 320c-48.3 0-87.8 35.7-94.6 82.1C53.9 363.6 32 312.4 32 256c0-119.1 96.9-216 216-216s216 96.9 216 216c0 56.4-21.9 107.6-57.4 146.1zM248 120c-48.6 0-88 39.4-88 88s39.4 88 88 88 88-39.4 88-88-39.4-88-88-88zm0 144c-30.9 0-56-25.1-56-56s25.1-56 56-56 56 25.1 56 56-25.1 56-56 56z"
    })
  );
};

UserIcon.defaultProps = {
  width: 18,
  height: 19,
  color: 'currentColor'
};

exports.default = UserIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/components/Icon/UserIcon.js
// module id = 63
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38